import React from "react";
import {CellTemplateProps, ColumnProps} from "fulogics-ui-web";
import GridColumnInspectorHelper from "fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper";
import TruckFilling, {
    TruckFillingData, TruckFillingDataKeys,
    TruckFillingDisplayOptions
} from "../../../../components/truck-filling/TruckFilling";


const TruckFillingColumnTemplate = (props: CellTemplateProps) => {

    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) =>
                    <TruckFilling
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={props.data}
                        defaultProps={TruckFillingColumnTemplateDefaultProps}
                    />
                }
            </GridColumnInspectorHelper>
        </React.Fragment>
    )
}



export const TruckFillingColumnTemplateDefaultProps = {} as TruckFillingDisplayOptions;

export const TruckFillingColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current
    }
}

export type  TruckFillingColumnTemplateData = TruckFillingData &
    {};

export const TruckFillingColumnTemplateDataKeys =
    [
        ...TruckFillingDataKeys
    ]


export default TruckFillingColumnTemplate;


